import { Suspense, useMemo } from "react";
import { fetchKmsData } from "@kaltura/mediaspace-shared-utils";
import { ErrorBoundary, SimpleThumbnail } from "@kaltura/mediaspace-shared-ui";
import { Player } from "./Player";
import { KalturaBaseEntry } from "kaltura-typescript-client/api/types/KalturaBaseEntry";

export interface PlayerContainerProps {
    /**
     * kms endpoint for getting a ks
     */
    url: string;

    /**
     * the entry to play
     */
    entry: KalturaBaseEntry;
}

function PlayerContainer(props: PlayerContainerProps) {
    const { url, entry } = props;

    // fetch data from kms
    const fetchModuleData = useMemo(() => {
        return fetchKmsData<{ ks: string }>(url, { entryId: entry.id }, true);
    }, [entry, url]);

    const thumbnail = (
        <SimpleThumbnail
            thumbnailUrl={`${entry.thumbnailUrl}/width/552/height/311/type/3`}
            name={entry.name}
            roundCorners={false}
        />
    );

    // render with Suspense
    return (
        <ErrorBoundary fallback={thumbnail}>
            <Suspense fallback={thumbnail}>
                <Player fetchModuleData={fetchModuleData} entry={entry} thumbnail={thumbnail} />
            </Suspense>
        </ErrorBoundary>
    );
}

export default PlayerContainer;
